//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OriginalFile from '@/components/OriginalFile'
import ContractOrder from './components/ContractOrder'
import ContractLand from './components/ContractLand'
export default {
  name: 'ContractDetail',
  components: {
    OriginalFile,
    ContractOrder,
    ContractLand,
  },
  data() {
    return {
      id: '',
      detail: {},
      info: [],
      activeName: 'first',
      isRequest: false,
    }
  },
  filters: {
    formatDate(value) {
      let result = `${value.allottedTimeBegin}~${value.allottedTimeEnd}`
      return result
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.getContractDetail()
  },
  methods: {
    /**
     * @descripttion: 获取合同详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getContractDetail() {
      this.$http.contract.getContractDetail({ id: this.id }).then((res) => {
        this.isRequest = true
        this.detail = res.data
        this.info = [res.data]
      })
    },
  },
}
